import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { loadableReady } from '@loadable/component';
import 'regenerator-runtime/runtime';

import App from './App';

loadableReady(() => {
  ReactDOM.hydrate(
    <BrowserRouter>
      <App data={window.__INITIAL_STATE__} />
    </BrowserRouter>,
    document.getElementById('root')
  );
});

if (module.hot) {
  module.hot.accept('./App', () => {
    loadableReady(() => {
      const UpdatedApp = require('./App').default;
      ReactDOM.hydrate(
        <BrowserRouter>
          <UpdatedApp data={window.__INITIAL_STATE__} />
        </BrowserRouter>,
        document.getElementById('root')
      );
    });
  });
}
